import { createReducer } from "@reduxjs/toolkit";

const initialState = [];

/**
 * Keeps service plan state
 *
 * @param  {Array} state: the new state
 * @param  {Object} action: action to be performed
 * @return {Object} the new state
 */
const overwriteResources = createReducer(initialState, {
  GET_OVERWRITE_RESOURCES: (state, { value }) => value.payload,
});

export default overwriteResources;
